<template>
  <div id="app" :style="{height: height}">
    <Image360 v-if="name" :texturePath="getTexturePath(name)" :quality="quality"/>
  </div>
</template>

<script>
import Image360 from './components/project/Image360.vue'

export default {
  name: 'app',
  components: {Image360},
  data () {
    return {
      name: null,
      quality: 0.8,
      height: '400px'
    }
  },
  created () {
    this.name = this.getQueryVariable('name')
    this.quality = this.getQueryVariable('quality') || this.quality
    this.height = this.getQueryVariable('height') || this.height
  },
  methods: {
    getTexturePath (name) {
      return `https://www.straitstimes.com/multimedia/graphics/assets/widget-assets/360-image-widget/${name}.jpg`
    },
    getQueryVariable (variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] === variable) return pair[1]
      }
      return false
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;

  #app {
    position: relative;

    canvas {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
